<template>
    <div class="container">
        <div class="row mt-3 mb-3">
            <div class="col-md-4 col-sm-6 mx-auto text-center">
                <p class="recipe-name">Selected recipe: {{ project.recipe.name }}</p>
            </div>
        </div>
        <div v-if="project.recipe.uses_column">
            <div class="row mt-2 mb-3">
                <div class="col-6 mx-auto">
                    <icon-with-message img-src="/img/picto-lamp-red.svg" title="Hint" text-color="#3040C4">
                        <template v-slot:content>
                            Your data has <strong>{{ columns.length }}</strong> columns. The algorithm will try to guess
                            one
                            column based on the others.<br/>
                            Click <a href="#" data-toggle="modal"
                                     :data-target="'#recipe-' + project.recipe.id + '-modal'">here</a>
                            to see how it works. In order to continue, please select a column:
                        </template>
                    </icon-with-message>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6 col-sm-11 mx-auto">
                    <div class="form-group">
                        <select class="form-control" id="selectColumn" v-model="columnIndex">
                            <option
                                v-for="column in columns"
                                :key="column.columnIndex"
                                :value="column.columnIndex">
                                {{ column.value }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <run-recipe-analysis v-bind:ready-for-analysis="readyForAnalysis">
        </run-recipe-analysis>
    </div>
</template>
<script>
    import {mapActions, mapGetters} from 'vuex';
    export default {
        data: function () {
            return {

            }
        },
        computed: {
            ...mapGetters([
                'project',
                'columns'
            ]),
            columnIndex: {
                set(index) {
                    this.setProject({...this.project, prediction_column_index: index});
                },
                get() {
                    return this.project.prediction_column_index;
                }
            },
            readyForAnalysis: function () {
                if (!this.project.recipe.uses_column)
                    return true;
                return this.project.prediction_column_index !== undefined;
            }
        },
        methods: {
            ...mapActions([
                'setProject'
            ])
        }
    }
</script>
<style lang="scss" scoped>
    @import "../../sass/variables";

    .recipe-name, .column-label {
        font-size: 1.2rem;
        font-weight: 500;
        color: $blue;
    }

    select.form-control {
        border-color: $blue;
        border-radius: 60px;
        padding: 1.7rem 1rem;
        font-size: 1rem;
        height: auto;
    }

    .btn {
        padding-top: 1.7rem;
        padding-bottom: 1.7rem;
        font-weight: 400;
    }

</style>
